require('dotenv').config();

const { APP_MODE } = process.env;

const STRIPE_LINKS = {
  development: {
    payment: (id) => `https://dashboard.stripe.com/test/payments/${id}`,
    subscription: (id) => `https://dashboard.stripe.com/test/subscriptions/${id}`,
  },
  staging: {
    payment: (id) => `https://dashboard.stripe.com/test/payments/${id}`,
    subscription: (id) => `https://dashboard.stripe.com/test/subscriptions/${id}`,
  },
  production: {
    payment: (id) => `https://dashboard.stripe.com/payments/${id}`,
    subscription: (id) => `https://dashboard.stripe.com/subscriptions/${id}`,
  },
};

module.exports = (request) => {
  const { paymentIntentId, subscriptionId } = request;
  if (subscriptionId) return STRIPE_LINKS[APP_MODE].subscription(subscriptionId);
  return STRIPE_LINKS[APP_MODE].payment(paymentIntentId);
};
